module.exports = __webpack_public_path__ + "img/weifachubeihuoneirong.e1f8790d.png";